
import { Twitter, Facebook, Instagram } from "lucide-react";
import { motion } from "framer-motion";

const socialLinks = [
  {
    icon: Twitter,
    url: "https://x.com/Cibeto07",
    label: "Twitter",
    color: "hover:text-blue-500"
  },
  {
    icon: Facebook,
    url: "https://www.facebook.com/profile.php?id=61574970732236",
    label: "Facebook",
    color: "hover:text-blue-700"
  },
  {
    icon: Instagram,
    url: "https://www.instagram.com/cibeto07/",
    label: "Instagram",
    color: "hover:text-pink-600"
  }
];

export function SocialLinks() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 5 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.div 
      className="mt-8 pt-6 border-t border-gray-200"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="flex flex-col items-center">
        <p className="text-sm text-gray-500 mb-4">Connect with us</p>
        <motion.div className="flex justify-center gap-6">
          {socialLinks.map((social, index) => (
            <motion.a
              key={social.label}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`text-gray-500 ${social.color} transition-all duration-300 transform hover:scale-110`}
              title={social.label}
              variants={itemVariants}
              whileHover={{ y: -3 }}
              whileTap={{ scale: 0.95 }}
              aria-label={`Visit our ${social.label} page`}
            >
              <social.icon className="w-6 h-6" />
            </motion.a>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
}
